import { CURRENCIES } from '../constants/currency-symbol';

export enum Billing {
    Epoch = 'Epoch',
    CentroBill = 'CentroBill',
    UpGate = 'UpGate',
    PayGarden = 'PayGarden',
    Bitpace = 'Bitpace',
}

export enum PaymentMethod {
    CreditCard = 'card',
    Paypal = 'paypal',
    UPI = 'upi',
    Ideal = 'ideal',
    PaySafeCard = 'paysafecard',
    Discover = 'discover',
    JCB = 'jcb',
    EPS = 'eps',
    Multibanco = 'multibanco',
    Pix = 'pix',
    Przelewy24 = 'przelewy24',
    Blik = 'blik',
    BanContact = 'bancontact',
    Sepa = 'sepa',
    Boleto = 'boleto',
    Epaybg = 'epaybg',
    Euteller = 'euteller',
    Paysera = 'paysera',
    PSE = 'pse',
    Spei = 'spei',
    OnlineBanking = 'onlinebanking',
    GiftCard = 'giftcard',
    MBWay = 'mbway',
    PagoEfectivo = 'pagoefectivo',
    Sofort = 'sofort',
    Klarna = 'klarna',
    Wechat = 'wechat',
    Alipay = 'alipay',
    KakaoPay = 'kakao_pay',
    Crypto = 'crypto',
    NaverPay = 'naver_pay',
    Neosurf = 'neosurf',
    CashtoCode = 'cashtocode',
    SEPAInstant = 'sepa_instant',
    Havale = 'havale12',
    BKASH = 'bKash',
}

export enum PaymentCardBrand {
    Visa = 'visa',
    Mastercard = 'mastercard',
    Jsb = 'jcb',
    AmericanExpress = 'americanexpress',
    Diners = 'diners',
    Discover = 'discover',
    Maestro = 'maestro',
    UnionPay = 'unionpay',
    RuPay = 'rupay'
}

export type OpenExchangeCurrency = (typeof CURRENCIES)[number]['code'];
export type OpenExchangeCurrencySymbol = (typeof CURRENCIES)[number]['symbol'];

export enum Currency {
    Usd = 'USD',
    Eur = 'EUR',
    Gbp = 'GBP',
}
